import {useState} from 'react'
import ButtonNavigation from '../components/ButtonNavigation'
import {ButtonSubmit} from '../Form'
import {InternalProps} from './models'
import {toast} from 'react-toastify'

export default function InternalNavigation<T>({
    setTouched,
    loading = false,
    pages,
    labels,
    buttonNext,
    titleSubmit,
    pageFields,
}: InternalProps<T>) {
    const keys = Object.keys(pages)
    const [page, setPage] = useState(keys[0])

    async function selectPage(key: string) {
        const index = keys.indexOf(page)
        if (setTouched && pageFields && !inLastPage()) {
            let errors: any = await setTouched(pageFields[index])
            let errorC = 0
            for (const key in pageFields[index]) {
                if (key in errors) {
                    errorC++
                    break
                }
            }
            if (errorC === 0) {
                if (index < keys.length - 1) {
                    setPage(key)
                    return
                }
            } else {
                console.log(errors)
            }

            toast.error('Campos obrigatórios não preenchidos!')
            return
        }

        setPage(key)
    }

    async function verifyForm() {
        if (!pageFields) return
        if (!setTouched) return
        let map: any = {}
        for (let i = 0; i < pageFields.length; i++) {
            let pageField: any = pageFields[i]
            let fieldKeys: string[] = Object.keys(pageField)
            for (let j = 0; j < fieldKeys.length; j++) {
                map[fieldKeys[j]] = pageField[fieldKeys[j]]
            }
        }
        if (!map || !setTouched) return
        let errors: any = await setTouched(map)
        let errorC = 0
        for (const key in map) {
            if (key in errors) {
                errorC++
                break
            }
        }
        if (errorC === 0) {
            return
        }
        console.log(errors)
        toast.error('Campos obrigatórios não preenchidos!')
    }

    async function nextPage() {
        const index = keys.indexOf(page)
        if (setTouched && pageFields) {
            let errors: any = await setTouched(pageFields[index])
            let errorC = 0
            for (const key in pageFields[index]) {
                if (key in errors) {
                    errorC++
                    break
                }
            }
            if (errorC === 0) {
                if (!inLastPage()) {
                    setPage(keys[index + 1])
                    return
                }
            } else {
                console.log(errors)
            }

            toast.error('Campos obrigatórios não preenchidos!')
            return
        }
        if (!inLastPage()) {
            setPage(keys[index + 1])
        }
    }

    function inLastPage() {
        return keys.indexOf(page) === keys.length - 1
    }

    return (
        <div className='d-flex flex-column flex-md-row'>
            <menu className='m-0 p-0'>
                <ul className='p-0 me-6'>
                    {keys.map((key, index) => (
                        <ButtonNavigation
                            onClick={() => selectPage(key)}
                            label={labels[index]}
                            active={page === key}
                            key={key}
                        />
                    ))}
                </ul>
            </menu>
            <main className='w-100'>
                {pages[page]}
                {buttonNext && (
                    <div className='d-flex w-100 justify-content-end my-4'>
                        {!inLastPage() ? (
                            <button
                                type='button'
                                className='btn btn-light-primary'
                                onClick={() => nextPage()}
                            >
                                Próxima
                                <i className='ms-2 fas fa-arrow-right' />
                            </button>
                        ) : (
                            <ButtonSubmit
                                onConfirmClick={() => verifyForm()}
                                loading={loading}
                                title={titleSubmit}
                            />
                        )}
                    </div>
                )}
            </main>
        </div>
    )
}
